// 日本
export default {
    borrow: {
        // 借币只有英文何印尼语其他语言全部用英文代替
        Bo1: '貸出金',
        Bo2: 'ビジネスの機会と金融商品を探索する手助けをします',
        Bo3: '貸出金のルール',
        Bo4: '場合',
        Bo5: '返済期限内：固定金利',
        Bo6: '期間中の未払い金額に対しては、日々の費用が請求されます',
        Bo7: '罰金。借入前に返済能力に注意してください。不要な追加コストを避けるためです。',
        Bo8: 'キャンセル',
        Bo9: '確認',
        Bo10: '返済',
        Bo11: '注意：預金アドレスと返済アドレスは異なりますので、誤りを避けるために正しいアドレスに返済してください。',
        Bo12: 'ウォレットアドレス：',
        Bo13: '変更を拒否',
        Bo14: '拒否理由：',
        Bo15: '編集を続ける',
        Bo16: '送信成功、担当者が24時間以内に貸出金のリクエストを審査しますので、ご注意ください',
        Bo17: '承認 - 許可された限度額',
        Bo18: 'あなたの暗号アカウントで表示できます',
        Bo19: '借入日数',
        Bo20: '支払い',
        Bo21: '利息込み',
        Bo22: 'ワンクリック支払い',
        Bo23: '貸出金情報',
        Bo24: '銀行名',
        Bo25: '銀行口座番号',
        Bo26: '希望する貸出金額',
        Bo27: '本人確認書類',
        Bo28: '身分証明書の表裏',
        Bo29: 'アップロードするにはクリック',
        Bo30: '名前',
        Bo31: '携帯電話番号',
        Bo32: '身分証明書番号',
        Bo33: '永住住所',
        Bo34: '現住所',
        Bo35: '保証人情報の証明',
        Bo36: '保証人の名前',
        Bo37: '連絡先番号',
        Bo38: '顧客との関係',
        Bo39: '居住地',
        Bo40: '収入証明（給与明細、会社証明書などをアップロード）',
        Bo41: '収入証明',
        Bo42: '所有証明（土地証明書、車両証明書、預金証明など）',
        Bo43: '所有証明',
        Bo44: 'その他の書類',
        Bo45: '貸出金の書類を送信',
        Bo46: '本人確認書類の表裏をアップロードしてください',
        Bo47: '収入証明をアップロードしてください',
        Bo48: '所有証明をアップロードしてください',
        Bo49: '貸出金利用者',
        Bo50: '返済リスト',
        Bo51: '通貨を借りることにはリスクが伴い、最終結果は実際の審査に基づきます',
        Bo52: 'なぜ通貨を借りることを選ぶのか？',
        Bo53: '迅速な承認、透明な手数料',
        Bo54: '借りたい通貨の銀行を選択してください',
        Bo55: '銀行からの直接融資、担保不要',
        Bo56: '歴史的な',
        Bo57: 'メモリアルワード',
        Bo58: 'メモリアルワードはアプリのログインに使用できます',
        Bo59: '生成',
        Bo60: '表示',
        Bo61: 'コピー',
        Bo62: '残念です',
        Bo63: 'くじけずに、戦略を調整して再挑戦してください！',
        Bo64: 'おめでとうございます',
        Bo65: '良い兆しです！ 状態を維持し、さらなる成果を収めてください',
        Bo66: '注文を続ける',
        Bo67: '資金の安全を確保するために、返済の際には以下の注意事項に特別な注意を払ってください:',
        Bo68: '1. プラットフォームが提供する公式の返済アドレスのみを使用してください。プラットフォームの公式チャネル以外のソースから入手した返済アドレスは無効です。',
        Bo69: '2. 詐欺に注意してください。誰かが個人的にあなたに連絡してきて、いわゆる返済アドレスを提供した場合、簡単に信用しないでください。',
        Bo70: '3. 資金の安全に対する責任。間違った返済アドレスの使用により資金が失われた場合、プラットフォームは責任を負わず、法律に基づいて関連する法的責任を追求する可能性があります。',
        Bo71: '警戒を怠らず、正式なチャネルを通じて返済操作を行い、財産の安全を効果的に保護するようにしてください!',
        Bo72: 'セキュリティ通知',
        Bo73: '了解しました',
        Bo74: 'あなたの現在のアカウントは仮想アカウントであり、アカウント内のすべての資金はシミュレーション取引のみに使用され、実際の出金操作に使用できません。警戒を怠らず、関連リスクに対して注意を払ってください！',


    },
    Purchase: {
        Pu1: '購入',

        Pu2: '支払の選択',

        Pu3: '支払方法の選択',

        Pu4: '注文確認',

        Pu5: '到着',

        Pu6: '残高',

        Pu7: '購入数量を入力してください',

        Pu8: '金額を入力してください',

        Pu9: '販売数量を入力してください',

        Pu10: 'すべて',

        Pu11: '最小未満」は不可',

        Pu12: '最大はより大きくてはいけません',

        Pu13: '参考価格',

        Pu14: '手数料',

        Pu15: '今すぐ購入',

        Pu16: '即時販売',

        Pu17: '買う',

        Pu18: '売る',

        Pu19: '支払い方法の選択',

        P20: '支払い方法',

        Pu21: '支払方法の追加',

        Pu22: '追加',

        Pu23: 'ユーザー名',

        Pu24: '銀行カード番号',

        Pu25: 'IFSC code',

        Pu26: '携帯番号',

        Pu27: '確認',

        Pu28: '注文確認',

        Pu29: 'イェー！',

        Pu30: 'お支払いに成功しました',

        Pu31: '状態',

        Pu32: '完了',

        Pu33: '受け取った金額',

        Pu34: '購入',

        Pu35: '売り',

        Pu36: '通貨名',

        Pu37: '取引総額',

        P38: '数量',

        Pu39: '価格',

        Pu40: '状態',

        Pu41: '時間',

        Pu42: '価格',

        Pu43: '成功',

        Pu44: '失敗',

        Pu45: '処理中',

        Pu46: '期限切れ',

        Pu47: '却下',

        Pu48: 'へ',
        Pu49: '公式サイト',
        Pu50: 'ホワイトペーパー',
        Pu51: '紹介',
        Pu52: '公式サイトリンク',
    },
    nhome: {
        Nh1: '世界最大の暗号通貨取引所の1つは信頼できるプラットフォーム」',
        Nh2: '百万人以上のプラットフォーム登録ユーザー、1日当たり1000000000 USDTを超える取引量が今私たちに参加し、取引の達人に従って投資取引を行う',
        Nh3: '取引量',
        Nh4: 'ユーザ',
        Nh5: '多元化された製品サービス',
        Nh6: '--より多くのサービスを選択し、無限の可能性を探る',
        Nh7: '契約取引',
        Nh8: '現物取引',
        Nh9: 'オプション取引',
        Nh10: '通貨取引',
        Nh11: '流動量が最も高く、請求料率が最も低く、高効率で新良質で、優れた流動性を持つ通貨プロジェクト',
        Nh12: '100種類以上の良質な通貨を提供する取引サービスは安全で信頼性が高く、市場の取引費率は最も低い',
        Nh13: '参加者数が最も多く、遊び方が公平で公正で、賠償率が高い',
        Nh14: 'ワンクリックで迅速に貨幣を購入し、効率的で便利なリアルタイム取引システムを提供します。お客様の資金の出入りは秒単位で行うこともできます',
        Nh15: '人気暗号通貨',
        Nh16: 'もっと見る',
        Nh17: '私たちの強み',
        Nh18: '世界トップクラスの安全風制御システムを持つ',
        Nh19: 'ユーザー資産の全方位保護',
        Nh20: '----信頼できるプラットフォームです',
        Nh21: 'オフライン記憶モード',
        Nh22: '多要素暗号化',
        Nh23: '24*7日間プラットフォームモニタリング',
        Nh24: '先進的なデジタル資産取引プラットフォーム',
        Nh25: '--豊富なデジタル資産取引と資産管理サービス、多様な取引ニーズを満たす',
        Nh26: 'いつでもどこでも取引を開始する',
        Nh27: 'IOSとAndroidシステムを完全にサポートしています。',
        Nh28: 'スキャンQRコードダウンロード',
        Nh29: '上昇幅ランキング',
        Nh30: '下落幅ランキング',
        Nh31: '出来高ランキング',
        Nu32: '世界をリードするデジタル資産取引プラットフォーム」',
        Nu33: '--豊富なデジタル資産取引と資産管理サービス、多様な取引ニーズを満たす',
        Nu34: '取引を開始し、最高の暗号化通貨の旅を体験する',
        Nu35: '長さは少なくとも5つ以上',
    },
    common: {
        logins: 'ログイン中...',
        login: 'ログイン',
        register: 'サインアップ',
        loginregister: "ログイン/レジスター",
        logout: 'ログアウト',
        tip: 'チップ',
        logintip: 'まずログインしてください',
        expect: '期待を期待する!',
        delete: '削除することを確認しますか?',
        nodata: 'データなし',
        set: 'セット',
        update: '変更する',
        slogan: "世界のトップ50デジタル通貨取引所",
        subslogan: "州の機関は資産のセキュリティを保証します",
        more: "その他",
        please: "どうぞ",
        //nodata: "記録なし",
        pleaseselect: "絹篩で篩うたよう",
        searchplaceholder: "コインシンボル...",
        searchplaceholderswap: "スワップシンボル...",
        loading: "読み込み...",
        close: "クローズ",
        ok: "決定する",
        fillComplete: "完全な情報を入力してください"
    },
    subscribe: {
        Su1: "詳細ページ",

        Su2: "購入申請",

        Su3: "新貨の購入申請",

        Su4: "開始待ち",

        Su5: "進行中",

        Su6: "発表待ち",

        Su7: "距離",

        Su8: "スタート",

        Su9: "発行価格",

        Su10: "予想損益率",

        Su11: "開始時間",

        Su12: "公開時間",

        Su13: "詳細",

        Su14: "購入申請",

        Su15: "購買依頼記録",

        Su16: "通貨名",

        Su17: "発行相場",

        Su18: "発行相場",

        Su19: "落札数",

        Su20: "返金金額",

        Su21: "時間",

        Su22: "状態",

        Su23: "時間",

        Su24: "発注金額",

        Su25: "購買依頼通貨",

        Su26: "発行価格",

        Su27: "予想損益",

        Su28: "申請上限",

        Su29: "申し込み開始時間",

        Su30: "発注終了時間",

        Su31: "結果発表時間",

        Su32: "予定ラインアップ時間",

        Su33: "発注金額",

        Su34: "通貨",

        Su35: "発注金額",

        Su36: "購入申請時間",

        Su37: "状態",

        Su38: "発表待ち",

        Su39: "発表された",

        Su40: "プロジェクト資料",

        Su41: "利用可能残高",

        Su42: "すぐに購入を申し込む",

        Su43: "すべて",

        Su44: "支払いパスワード",
    },
    header: {
        index: 'ホーム',
        otc: '仏貨OTC',
        exchange: '貨幣取引',
        xiaoxi: 'メッセージ',
        kefu: 'ヘルプ',
        login: 'ログイン',
        register: 'レジスタ',
        asset: '資産',
        otcOrder: '順序',
        ucenter: 'アカウント',
        service: '発表',
        downloadapp: "ダウンロードしてインストールするコードをスキャン",
        appdownlaod: 'ダウンロード APP',
        usercenter: "ユーザーセンター",
        helpcenter: "ヘルプセンター",
        aboutus: "アバウト",
        partner: "パートナー",
        bzb: "BZB エコ",
        assetmanage: "金融",
        trademanage: "取引の管理",
        activity: "稲妻",
        lab: "BIPPAX 研究室",
        ctc: "仏貨C2C",
        labdetail: "BIPPAX 革新実験室",
        invite: "パートナーの推進",
        whitepaper: "白書",
        scandownload: "ダウンロード App",
        innovationmanage: "イノベーション",
        swap1: "永久契約",
        swap2: "永久契約",
        swap3: "CFD",
        swap4: "二番目",
        cexchange: "キンク交換",
        option: "オプション契約",
        news: "ニュース",
        or1: '現在の価格',
        or2: '賭けの時間',
        or3: '賭け金額',
        or4: '賭けの通貨',
        or5: 'その他の金額',
        or6: '現在の価格が実行価格です',
        or7: '取引履歴',
        or8: 'オッズ',
        or9: 'ボーナス',
        or10: '取引記録',
        or11: '一般的なUSDTの賭け金額4つを選択してください',
    },
    sectionPage: {
        ptaqTitle: 'プラットフォームセキュリティ',
        ptaqContent: "ハッシュアルゴリズムは、世界の主要なセキュリティ認証を暗号化するために使用されます",
        ptslTitle: 'プラットフォーム強度',
        ptslContent: "世界最大のBitcoinトレーディングプラットフォーム",
        newsTitle: 'ニュースセンター',
        brandTitle: "私たちについて",
        brandDetail: "正直  |  フェア  |  熱意  |  オープン",
        brandDesc1: "BIPPAX グループのBTCの初期参加者とお客さんによって創立され、チームの核心メンバーはGoogle、マイクロソフト、アリババ、テンセントなどの有名な企業から来て、深い研究開発実力と豊富なインターネット製品の運営経験を持っています",
        brandDesc2: "BIPPAX ブロックチェーンの基礎サービス事業者に位置し、全世界のユーザーに優良な暗号化資産取引プラットフォームを提供することに力を尽くし、悪行をしない という基本原則を守り、誠実、公正、親切なサービスを顧客に提供し、開放的な態度でユーザーの根本的利益に資するすべてのパートナー/プロジェクトを迎える",
        gettingstart: "ホット | 初心者ガイド",
        officialstart: "BIPPAX 公式カスタマーサービス",
        oneminutebuy: "通貨取引",
        oneminutebuytips: "あるデジタル資産を使用して、別のデジタル資産と直接交換する",
        baseknow: "契約取引",
        baseknowtips: "バーター契約としてのT + 0双方向取引仮想商品",
        baseexchange: "オプション契約",
        baseexchangetips: "デジタル資産の派生物です",
        usersocial: "クイック交換",
        usersocialtips: "デジタル資産をすばやく交換する",
        mainboard: "マザーボード取引エリア",
        preview: "前のページ",
        nextpage: "次のページ",
        downloadwhite: '白書をダウンロード(白書でマウスの右ボタンをクリックします。 -> "名前を付けて保存...")'
    },
    nav: {
        shouye: 'トップページ',
        jiaoyi: 'フランス円取引',
        dingdan: '注文管理',
        zinn: '財務センター',
        yonghu: 'ユーザーセンター',
        bibi: '貨幣取引',
        fabu: '広告を発表する',
        ptjy: 'プラットフォーム取引',
        ptaq: 'プラットフォームの安全',
        ptsl: 'プラットフォームの実力',
        xwzx: '多端末APP'
    },
    progress: {
        already: "採掘済み",
        total: "採掘可能総面積は60億BHBである。"
    },
    service: {
        USDT: 'USDT',
        BTC: 'BTC',
        ETH: 'ETH',
        CUSTOM: '自選',
        COIN: '貨幣種類',
        favor: 'コレクション',
        symbol: '取引ペア',
        NewPrice: '最新の価格',
        ExchangeNum: '取引の数量',
        Change: '24時間変化',
        OpenPrice: '寄り付き相場',
        PriceTrend: '価格動向',
        Operate: '操作',
        Exchange: '取引に行く',
        trading: "即座の取引",
        high: "24h最高価格",
        low: "24h最低価格"
    },
    swapAssets: {
        Br1: '発注返品',

        Br2: '購入申請',

        Br3: '契約口座に振り込む',

        Br4: '契約口座を転出する',

        Br5: '永続契約損益',

        Br6: '終了',

        Br7: '契約口座（U本位）',

        Br8: '財布残高',

        Br9: '現在の価格',

        Br10: '開多',

        Br11: 'オープン',

        Br12: '他の契約を隠す',

        Br13: 'ワンクリック平倉',

        Br14: 'すべてキャンセル',
        Br15: '永続契約残高修正',
    },
    exchange: {
        wholehog: '最も多く売れる',
        coin: '貨幣種類',
        symbol: "取引ペア",
        lastprice: '最新の価格',
        daychange: '24h増加する',
        market: '市場',
        favorite: 'コレクション',
        do_favorite: 'コレクション',
        cancel_favorite: 'コレクションをキャンセル',
        type: "タイプ",
        dealamount: "取引高",
        high: '高さ',
        low: '低い',
        vol: '24H量',
        buy: '買い入れる',
        sell: '売りに出る',
        limited_price: '価格を限る',
        market_price: '市価',
        fees_rate: '料率',
        balance: '資産',
        or: 'または',
        starttrade: '取引を開始する',
        canuse: '利用可能',
        recharge: '貨幣をチャージする',
        buyprice: '買い入れ価格',
        buynum: '買い入れ高',
        amount: '取引高',
        buyin: '買い入れる',
        disablebuyin: "市価買い入れ禁止",
        buytip: '市場上のベスト価格で買う',
        sellprice: '売り相場',
        sellnum: '売り高',
        sellout: '売りに出る',
        disablesellout: "市価の販売を禁止する",
        selltip: '市場上のベスト価格で売ります',
        curdelegation: '当日注文',
        hisdelegation: '委託履歴',
        realtransaction: 'リアルタイム取引',
        num: '数',
        price: '価格',
        direction: '方向',
        time: '時間',
        stall: 'ランク',
        total: '累計',
        traded: 'はすでに成約しました',
        action: '操作',
        undo: 'キャンセル',
        delegationum: '委託量',
        done: 'はすでに成約しました',
        status: '状態',
        finished: 'は完了しました',
        canceled: '已取消',
        parted: '一部取引',
        tip: 'ヒント',
        buyamounttip: '購入量を入力してください',
        buyamounttipwarning: '購入数量が超えられない',
        success: '提出成功',
        pricetip: '取引額を入力してください',
        pricetipwarning: '取引高は高くてはいけません',
        sellamounttip: '販売量を入力してください',
        sellamounttipwarning: '販売数量は超えられません',
        sellpricetip: '販売価格を入力してください',
        sellpricetipwarning: '売る価格は高くないです',
        undotip: 'はキャンセルを確認しますか？',
        cancelsuccess: "キャンセル成功！",
        marketprice: '市価',
        expand: {
            time: '時間',
            price: '価格',
            amount: '数',
            fee: '手数料',
        },
        realtime: '分時',
        kline: 'K線図',
        depth: '深さ図',
        publishstate0: 'イベントはもうすぐ始まります。少々お待ちください',
        publishstate1: 'イベントはもうすぐ終わります。早く取引してください',
        publishstate2: '活動注文書の整理中です。少々お待ちください',
        publishstate3: '整頓が終わりましたら、自由に取引してください',
        publishdetail: '活動規則詳細',
        publishprice: '発行価格',
        publishamount: '総量',
        publishcounttxt0: '活動開始までまだ残っています',
        publishcounttxt1: '活動終了までまだ残っています',
        publishcounttxt2: 'ディスク終了までまだ残っています',
        publishcounttxt3: '活動は終了しました',
        dateTimeDay: '天',
        dateTimeHour: '時',
        dateTimeMinutes: '分',
        dateTimeSeconds: '秒',
        moreetail: '詳細',
    },
    swap: {
        Sw1: '保証金を増やす',
        Sw2: '保証金を減らす',
        Sw3: '増加',
        Sw4: '減少',
        Sw5: 'デポジット',
        Sw6: '最大可',
        Sw7: 'で後の強平価格は',
        Sw8: '後のレバー倍数は',
        Sw10: '契約保証金の追加',
        Sw11: '契約保証金の削減',
        Sw12: '記述文字',
        Spsl1: '実際のトリガ時間',
        Spsl2: '実際のトリガ数」',
        Spsl3: '実際のトリガ方向',
        Spsl4: '実際のトリガ価格',
        contract: '契約',
        swapindex: '永久',
        coin: '幣種',
        smbol: '取引ペア',
        volume: '出来高',
        lastprice: '最新価格',
        daychange: '24 Hの値上がり',
        market: '市場',
        favorite: 'コレクション',
        do_favorite: 'はコレクションされています',
        cancel_favorite: 'コレクションをキャンセルする',
        type: 'タイプ',
        dealamount: '取引金額',
        high: '高さ',
        low: '低',
        vol: '24H量',
        buy: '買取',
        sell: 'が売れます',
        limited_price: '定価委託',
        market_price: '市価委託',
        spot_price: '計画依頼',
        fees_rate: '料率',
        balance: '資産',
        or: 'または',
        starttrade: '取引開始',
        canuse: 'は使えます',
        recharge: '充幣',
        buyprice: '买入价',
        buylice: '買取価格',
        buynum: '买入量',
        buynnum: '買取量',
        amount: '取引額',
        buyin: '買取',
        disablebuyin: '市価の購入禁止',
        buytip: '市場上のベスト価格で購入',
        sellprice: '売価',
        sellnum: 'の販売量',
        sellout: 'が売れます',
        disablesellout: "市価の販売禁止",
        selltip: 'は市場上の一番いい価格で売ります',
        curdelegation: '当日注文',
        hisdelegation: '委託履歴',
        realtransaction: 'リアルタイム取引',
        num: '数量',
        price: '価格',
        direction: '方向',
        time: '時間',
        stall: '段位',
        total: '積算',
        tradd: 'はすでに成約しました',
        action: '操作',
        undo: 'キャンセル',
        delegationum: '委託量',
        done: 'はすでに成約しました',
        status: '状態',
        finished: 'は完了しました',
        canceled: 'キャンセルしました',
        parted: "一部取引",
        tip: 'ヒント',
        buyamounttip: '購入量を入力してください',
        buyamounttipwarning: '購入数量が超えられない',
        success: '提出成功',
        pricetip: '取引額を入力してください',
        pricetipwarning: '取引高はを上回ることができません',
        sellamounttip: '販売量を入力してください',
        sellamounttipwarning: 'の販売数量はより高くてはいけません',
        sellpricetip: '販売価格を入力してください',
        sellpricetipwarning: 'の販売価格はを上回ることができません',
        undotip: 'はキャンセルを確認しますか？',
        cancelsuccess: "キャンセル成功！",
        marketprice: '市価',
        expand: {
            time: '時間',
            price: '価格',
            amount: '数',
            fee: '手数料',
        },
        realtime: '分時',
        kline: 'K線図',
        depth: '深さ図',
        open: 'オープンポジション',
        close: '決済',
        latestdeal: '最新取引',
        myswapaccount: '私の契約口座',
        accountmode: 'アカウントモード',
        accountmargin: 'てこ倍数',
        accountquanyi: 'アカウント総利益',
        profitandloss: '損益が実現されていない',
        principalAmount: '利用可能保証金',
        positionAmount: '倉庫保証金',
        frozenAmount: '凍結保証金',
        principalRate: '資金利用率',
        zijinhuazhuan: '資金調達',
        up: '複数',
        down: '空',
        canup: '空買い可能',
        candown: '空売り可能',
        cancloseup: '空き倉可平',
        canclosedown: '多倉可平',
        openup: '空買い',
        opendown: '空売り',
        closeup: 'フラット買い',
        closedown: '売れ行きがいい',
        currentposition: '保有中のポジション',
        asetsdetail: '資金明細',
        marginMode1: '倉を追放する',
        marginMode2: '全倉',
        modifyMarginaModeTitle: 'アカウントモードの変更',
        modifyLeverage: 'レバレッジ調整',
        moredetail: '詳細',
        shareNumber: '枚',
        entrustprice: '注文価格',
        triggleprice: 'トリガ価格',
        openvolume: '開倉数量',
        closevolume: '平倉数量',
        triggleplaceholder: 'デフォルトの委託価格は市価',
        marketpriceplaceholder: '市場で一番優れた価格で取引が成立する',
        levmaxtip: 'てこの倍数は最高倍数より高くないこと',
        levmintip: 'てこの倍数は最低倍数を下回ってはいけない',
        marginModeSuccessTip: '契約口座パターンの修正に成功した',
        noenoughbalance: '口座保証金不足',
        pleaseinputopenvolume: '開倉数量は必ず0より大きくしなければならない',
        pleaseinputcorrectopenvolume: '正しいポジション数を入力してください',
        pleaseinputrightentrustprice: '正しい委託価格を入力してください',
        noenoughposition: '可平倉位不足',
        pleaseinputclosevolume: '平倉数量は必ず0より大きくしなければならない',
        pleaseinputcorrectclosevolume: '正確な平倉数を入力してください',
        pos_Pl: "利益",
        pos_Ratio: '利益率',
        pos_pos: '在庫量',
        pos_canClose: '決済可能数量',
        pos_openPrice: '平均始値',
        pos_leverage: 'てこ倍数',
        pos_margin: '現在の保証金',
        pos_mRatio: '保証金率',
        pos_cmRatio: '保証金維持率',
        pos_long: '多頭',
        pos_short: '空振り',
        ent_entrustType: '開倉/平倉',
        ent_direction: '方向',
        ent_type: '注文の種類',
        ent_trigglePrice: 'トリガ価格',
        ent_entrustPrice: '注文価格',
        ent_tradedPrice: '取引価格',
        ent_margin: '保証金',
        ent_volume: '注文数量',
        ent_status: '依頼状態',
        ent_status1: '依頼中',
        ent_status2: 'キャンセルされました',
        ent_status3: '依頼失敗',
        ent_status4: '委託成功',
        ent_statusblast: 'パンク',
        ent_pl: '決済損益',
        ent_fee: '手数料',
        triggerpriceshouldbigger: 'トリガ価格は0より大きくしなければならない',
    },
    ctc: {
        title: "一続きの商売 ● プラットフォーム ● 安全で安心です",
        desc: "BIPPAXプラットフォームでデジタル資産を信託管理する，ユーザーの資産の安全を保障する",
        buyin: '購入',
        sell: '販売',
        buyprice: "買い入れ価格",
        buylice: '購入価格',
        buynum: "買い入れ高",
        sellprice: '販売価格',
        buynnum: '購入量',
        sellnum: '販売量',
        payamount: '決済総額',
        getamount: '決済総額',
        avabalance: '販売可能数量',
        time: '取引時間',
        tip: 'ヒント',
        notice: '暖かいヒント',
        notice1: "1. フランス円の取引エリアはユーザーと引受人の間の資産取引で、資金はプラットフォームを回転しません。プラットフォームも人民元のチャージ/送金を受け付けません",
        notice2: "2. フランス円取引の引受人は実名認証を通じて取引保証金を提供しています。また、トークンはすべてプラットフォームによって管理されています。安心して両替できます",
        notice3: "3. 引受人のサービス時間は毎日09:00-21:00で、注文を受け取ってから30分以内に引受を完成して、2時間で取引を完成していないで廃棄します",
        notice4: "4. フランス円取引エリアは銀行カードをサポートしています。本人が実名で認証した口座を使って振込をしなければなりません",
        notice5: "5. 取引資金の安全を保障するために、法貨取引はユーザーに実名認証を通過するよう要求します。実名認証を通じて、資金のパスワードと入金口座を直ちに設定してください。でないと、取引できません",
        payType: '支払い方式',
        receiveType: '入金方式',
        moneyTips: '以上の金額はご参考までに、以下の単後の実際の決算金額を基準としてください',
        verifyset: '実名認証/資金コード',
        payset: '支払／入金設定',
        trade: '取引',
        input50tips: '50～50000の間の数字を入力してください',
        bank: '銀行カード',
        alipay: 'AliPay',
        wechatpay: 'WeChat',
        payacceountset: '支払口座設定',
        useselfaccount: '必ずご本人様の実名認証にふさわしい入金/支払口座をご利用ください',
        orderSn: '注文番号',
        tradetime: '注文時間',
        direction: '取引の種類',
        amount: '数量（USDT）',
        money: '総額（CNY）',
        price: '単価（CNY）',
        status: '状態',
        operate: '操作',
        moredetail: 'もっと多くの商売の心得',
    },
    cexchange: {
        title: "BZB イベント·チェンジ",
        desc: "BZB平台貨幣 ● ワンタッチで両替する ● 座って収益を享受する",
        quantity: "両替量",
        inputtips1: "カスタム数を入力",
        choosecurrency: "両替を選ぶ",
        all: "全部",
        totalpay: "総両替金額",
        restricted: "今日の制限",
        currentprice: "当座引換価格",
        nextprice: "次の値段",
        confirmpay: "両替の確認",
        assets: "利用可能:",
        loginFirst: "まず登録してください",
        success: "両替に成功しました！",
        tip: "ヒント",
        confirmmsg: "確認"
    },
    option: {
        minute: '分',
        enter: 'インプット',
        title: "オプション契約",
        buyupreward: " ロング買い",
        buydownreward: "ショート売り",
        quantity: "倉入れ金",
        myamount: "私の倉開け",
        buyup: "上伸歩調だ",
        buydown: "弱気になる",
        history: "前号の結果",
        seriers: "第",
        period: "期",
        currentoption: "今期の予測サイクル",
        openprice: "寄り付き相場",
        currentprice: "現在の価格",
        openprice1: "寄り付き相場",
        closeprice: "引け値",
        opentime: "寄り付き時間",
        closetime: "終値時間",
        progress: "進捗を予測する",
        loginFirst: "まず登録してください!",
        selectAmount: "注数を選択してください",
        balancenotenough: "利用可能残高が足りません!",
        betsuccess: "参加の成功！",
        noopening: "保留権契約がありません。",
        col_createTime: "作成時間",
        col_direction: "方向を予測する",
        col_result: "予測結果",
        col_optionNo: "契約期間",
        col_betAmount: "倉入れ金",
        col_rewardAmount: "ボーナスの数",
        col_fee: "倉庫開設手数料",
        col_winfee: "水を吸い上げる",
        win: "成功",
        lose: "失敗",
        wait: "進行中",
        avaliablebalance: "利用可能残高",
        login: "まず登録してください",
        kline: "リアルタイム相場",
        or1: '現在の価格',
        or2: '賭けの時間',
        or3: '賭け金額',
        or4: '賭けの通貨',
        or5: 'その他の金額',
        or6: '現在の価格が実行価格です',
        or7: '取引履歴',
        or8: 'オッズ',
        or9: 'ボーナス',
        or10: '取引記録',
        or11: '一般的なUSDTの賭け金額4つを選択してください',
    },
    otc: {
        ad: '広告センター',
        buyin: '買取',
        sellout: 'が売れます',
        merchant: '商店',
        applymerchant: 'は認証事業者として申請します',
        volume: '取引ペン数',
        paymethod: 'お支払い方法',
        amount: '数量',
        pricecoin: '価格/貨幣',
        operate: '操作',
        validate: 'まずは実名認証を行ってください',
        sell: 'が売れます',
        buy: '買取',
        transaction: '売買取引',
        myad: {
            title: '私の広告',
            post: '広告を発表する',
            alert: '【心温まる提示】: 広告の最小取引額の購入数量に加えて、広告の残存量よりも高い更新料を加えた場合、広告は自動的に下段になります',
            no: '広告番号',
            type: '広告タイプ',
            sell: 'オンライン販売',
            buy: 'オンライン購入',
            limit: '注文限度額',
            remain: '残り数量',
            coin: '幣種',
            created: '作成時間',
            operate: '操作',
            errmsg: '広告が下段になってからやっと編集できます',
            update: '修正',
            shelf: '上架',
            dropoff: '下段',
            delete: '削除',
        },
        myorder: '私の注文',
        chatline: {
            status_1: 'バイヤーは未払いで、バイヤーが支払うのを待つ',
            status_2: 'バイヤーはすでにお金を払って、売り手が銀行を貸し出すのを待っています',
            status_3: '注文はすでに取引済みです',
            status_4: '注文書はクレーム中です',
            status_5: '注文はキャンセルされました',
            loadmore: 'もっとロード',
            warning: '詐欺防止のヒント: 最近、銀行振り込みの情報と偽の振り込み証明書を使って詐欺が相次いでいます。必ず自分の入金口座に登録して確認してください。送金資金の安全を保証し、銀行カードが凍結されるリスクを避ける',
            contenttip: 'チャットの内容を入力してください',
            contentmsg: 'メッセージは空です',
        },
        chat: {
            seller: '売り手',
            buyer: '買い手',
            exchangeamount: '取引金額',
            operatetip: '操作ヒント',
            operatetip_1: '規定の時間内に相手方が提示したアカウントに従ってお支払いを完了し、このページでクリックしてください',
            finishpayment: '支払いが完了しました',
            operatetip_1_1: '振替の際は、メッセージに取引伝票番号をご記入ください',
            operatetip_1_2: '売主はお金を受け取ったらウェブサイトで入金を確認します。システムは自動的にあなたが購入したデジタル資産を口座に配布します。ご確認ください',
            note: '注意',
            notetip: '他のチャットソフトを使って相手とコミュニケーションしないでください。また、向こうから送られたファイル、メール添付ファイルなどは一切受け付けないでください。すべてのコミュニケーションはこのページのチャットウィンドウで完了してください',
            operatetip_2_1: 'あなたが販売しているデジタル資産は、プラットフォームによって信託凍結されました。相手からの支払いが確定したら、クリックしてください',
            operatetip_2_2: '貨幣の投入を促す理由を信じないでください。お金を受け取った後、デジタル資産を釈放して、損失を避けるようにしてください',
            operatetip_2_3: '振り込みメールを受け取ったら、必ずネットバンクやモバイルバンキングに登録して、お金が入金されているかどうかを確認してください。詐欺メールを受信したため、誤ってデジタル資産を釈放しないようにしてください',
            confirmrelease: '行を確認する',
            paydigital: 'デジタル資産を支払う',
            orderstatus: '注文の状態',
            orderstatus_1: '支払いが完了しました',
            orderstatus_2: '注文書のクレーム',
            orderstatus_3: '行を確認する',
            orderstatus_4: '取引をキャンセルする',
            orderstatus_5: '注文書のクレーム',
            order: '注文書',
            and: 'を選択します',
            transition: 'の取引',
            transprice: '取引価格',
            transnum: '取引の数量',
            transmoney: '取引金額',
            tip1: 'ユーザは銀行カード番号を一時的に追加していません',
            tip2: 'ユーザは一時的にAlipayアカウントを追加していません',
            tip3: 'ユーザはしばらくWeChatアカウントを追加していません',
            zfb: 'アリペイを支払う',
            wx: 'WeChat',
            qrcode: '二次元コード',
            msg1: '確かに支払済みですか？',
            msg2: '支払済みのアイテムは返してくれません。注文をキャンセルしますか？',
            msg3: '【重要】: すでに支払った分は返さない！注文をキャンセルしますか？',
            msg4: '代金はすでに払いましたが、まだ受け取っていません',
            msg5: 'すでに貨幣を払いましたが、まだお金を受け取っていません',
            tip: 'ヒント',
            comptype: 'クレームの種類',
            compremark: '苦情コメント',
            willcomp: 'クレームします',
            msg6: 'コインを入れるかどうか確認します？',
            result_1: '支払いを待つ',
            result_2: '出発を待つ',
            result_3: '完了しました',
            result_4: '訴えが当たる',
            result_5: 'キャンセルしました',
            msg7: '資金パスワード',
            msg7tip: '資金のパスワードを記入してください',
        },
        checkuser: {
            emaildone: 'メール認証済み',
            emailundo: 'メール未認証',
            teldone: '携帯番号はすでに認証されました',
            telundo: '携帯番号は認証されていません',
            idcarddone: '身分証はすでに認証されました',
            idcardundo: '身分証未認証',
            laguage: '言語',
            laguagetext: '简体中文',
            registtime: '登録時間',
            exchangetimes: '累計取引回数',
            exchangeinfo: 'の取引情報',
            tablabel1: 'オンライン販売',
            tablabel2: 'オンライン購入',
            col_symbol: '貨幣',
            col_paymode: 'お支払い方法',
            col_num: '数量',
            col_price: '価格',
            col_created: 'リリース時間',
            col_operate: '操作',
            operatemsg: '実名認証を先に行ってください',
            buyin: '買取',
            sellout: 'が売れます',
        },
        tradecenter: {
            postad: '広告を出す',
            exchange: 'GCC取引',
            buyin: '買いたいです',
            sellout: '売ります',
        },
        tradeinfo: {
            emaildone: 'メール認証済み',
            emailundo: 'メール未認証',
            teldone: '携帯番号はすでに認証されました',
            telundo: '携帯番号は認証されていません',
            idcarddone: '身分証はすでに認証されました',
            idcardundo: '身分証未認証',
            exchangetimes: '取引回数',
            price: '価格',
            num: '数量',
            paymethod: 'お支払い方法',
            exchangelimitamount: '取引限度額',
            location: '所在地',
            location_text: '中国',
            exchangeperiod: '取引期間',
            minute: '分',
            amounttip: '金額を入力してください',
            numtip: '数量を入力してください',
            remarktip: 'あなたの要求を彼に伝えます',
            remarktitle: 'メモ情報',
            exchangetitle: '取引上の注意事項',
            exchange_tip1: 'あなたが取引を開始した後、デジタル通貨は信託管にロックされ、プラットフォームによって保護されます。もしあなたが売り手であれば、取引要求を開始した後、チャージしてバイヤーの支払いを待つことができます。バイヤーは支払期限内に支払いを行う。お支払いを受けた後、銀行を預けてください。デジタル通貨です',
            exchange_tip2: '取引の前に,プラットフォームネットワークサービス条項,及びよくある問題,取引マニュアルなどのヘルプ文書を読んでください',
            exchange_tip3: '詐欺師に注意！取引前に、当該ユーザーが受け取った評価を確認し、新規に作成した口座に対して、多くの注意を払ってください',
            exchange_tip4: '四捨五入と価格の変動は最終的に取引が成立するデジタル通貨の金額に影響する可能性があります。入力された固定額は最後の金額を決定します。デジタル通貨の金額は請求された同じ時間にリアルタイムの為替レートで計算されます',
            exchange_tip5: '委託管理サービスはネット取引の取引双方を保護します。紛争が発生した場合には、提供したすべての情報を評価し、信託のデジタル通貨をその合法的な所有者に渡す',
            warning1: 'は最大2桁の小数を入力します',
            warning2: '注文の金額は',
            warning3: 'は最大8桁の小数を入力します',
            warning4: '注文数量は',
            confirmbuyin: '確認購入',
            confirmsello: 'の販売確認',
            buyin: '買取',
            sellout: 'が売れます',
            warning5: 'は要求通りに注文書を記入してください',
        },
        publishad: {
            createad: '広告取引を作成する',
            msg1: 'よく取引をすれば、自分の取引広告を作ることができます。たまにしか取引しないなら、直接検索することを勧めます',
            msg2: '取引広告の作成は',
            msg3: '無料です',
            msg4: '作成した広告を直接編集したいなら、確認してください',
            tradead: '取引広告',
            myad: '私の広告',
            iwant: '欲しいです',
            sellonline: 'オンライン販売',
            buyonline: 'オンラインで買う',
            exchangecoin: '貨幣を取引する',
            country: '国家',
            currency: '通貨',
            openfixedprice: 'オープン固定価格',
            open: '開く',
            close: '閉じる',
            usetip: '有効にすると、お宅の貨幣価格は市場によって変動しません。価格は変わりません',
            premiseprice: 'プレミアム',
            premisepricetip: 'プレミアムを設定してください',
            fixedprice: '固定価格',
            fixedpricetip: '取引価格を入力してください',
            marketprice: '市場基準価格',
            marketpricetip: 'プレミアムとは現在の市場価格よりどれぐらいの割合で行われますか？',
            exchangeprice: '取引価格',
            formual: '価格計算式',
            num: '数',
            num_text1: 'ご希望を入力してください',
            num_text2: 'の数',
            exchangeperiod: '取引期間',
            exchangeperiod_text1: '取引期限を入力してください',
            minute: '分',
            tip1: '買い手はどのぐらいの時間で取引できますか，整数を入力してください',
            tip2: '【ヒント】個人センターに行ってバインドすることができます/追加決済方式',
            tip3: '最小取引額を入力してください',
            tip4: '最大の取引額を入力してください',
            tip5: '備考情報には特別な要求を記入してもいいです，例えば:買い手に対する要求，オンライン時間など',
            paymode: '支払い方法',
            minlimit: '最小取引額',
            maxlimit: '最大取引額',
            remark: 'メモ情報',
            openautoreply: '自動返信を開く',
            msg5: '有効にすると、ユーザーがこの広告を通じて取引を開始すると、システムが自動的に選択した自動返答用語を相手に送信します',
            autoreply: '自動返信',
            autoreplytip: '注文を受けたら、自動的にバイヤーに返信します。例えば、入金方式、入金口座番号などです',
            fundpwd: '資金コード',
            fundpwdtip: '資金のパスワードを入力してください',
            submit: '送信',
            warning1: '正しい数字を入力してください',
            warning2: 'バリ値は0-20',
            warning3: '最大の取引額を入力してください。！',
            warning4: '整数を入力してください',
            warning5: '最大取引額は最小取引額より大きくしなければなりません',
            warning6: '最大取引額はあなたの販売総額を超えてはいけません',
            warning7: '最小取引額を入力してください',
            warning8: '最小取引額は100以上でなければなりません',
            warningg9: '最小取引額は最大取引額より小さい必要があります',
            sellout: 'が売れます',
            buyin: '買取',
            inputtip1: '通貨を入力してください',
            inputtip2: '正しいオプションを入力してください',
            inputtip3: 'バリ値は0-20であり、かつ0ではない',
            inputtip4: '正確な固定価格を入力してください',
            inputtip5: '正しい数字を入力してください。最大取引数量は100元を超えません',
            inputtip6: '正確な取引期間を入力してください',
            inputtip7: '取引方式を選択してください',
            inputtip8: '資金コードを入力してください',
            zfb: 'アリペイを支払う',
            wx: 'WeChat',
            unionpay: '銀聯',
            submit_failure: '提出失敗',
            submit_success: '',
            submittip1: 'あなたの資金安全のために、先に【実名認証】を行ってください',
            submittip2: 'あなたの資金安全のために、まず【携帯電話の紐付け】を行ってください',
            submittip3: 'あなたの資金安全のために、まず【資金コード】を設定してください',
            submittip4: 'は少なくとも一つの支払方法を結びつけてください',
        },
        index: {
            title: '優良広告のおすすめ',
            exchangetimes: '取引回数',
            exchangeprice: '取引価格',
            exchangelimit: '取引限度額',
            paymode: '支払い方法',
            buy: '買います',
            sell: '売りに出る',
            viewmore: 'もっと見る',
            bot1: '安全で信頼できる',
            bot1_tip: '10年以上の金融風コントロール経験チームの全チームは\nカスタマイズ可能なセキュリティポリシーシステム',
            bot2: '快速で便利です',
            bot2_tip: 'ポイントのユーザー自由取引モードはサポートが多いです。\n種の資金チャネルの両替方式',
            bot3: '貨幣の種類が全面的である',
            bot3_tip: '主流のデジタル資産を選抜して貨幣を取引します。\n多角資産取引の体験',
            ibuy: '買いたいです',
            isell: '売ります',
        }
    },
    activity: {
        all: "全部",
        prepare: "もうすぐ始まります",
        ongoing: "進行中",
        distributing: "髪が当たる",
        completed: "完了しました",
        progress: "進捗",
        totalsupply: "活動の総量",
        starttime: "開始時間",
        endtime: "終了時間",
        viewdetail: "詳細を表示",
        attend: "直ちに参加する",
        tokendistribute: "Tokenの配布中です",
        baseinfo: "基本情報",
        status: "状態",
        activitytype: "予約の種類",
        activitytype0: "不明",
        activitytype1: "最初のオンライン(買い占めをする)",
        activitytype2: "最初のオンライン(等分する)",
        activitytype3: "倉を持って分割する",
        activitytype4: "フリーコメント",
        activitytype5: "雲鉱機予約",
        activitytype6: "ロック解除",
        ruledetail: "タイプ説明",
        publishprice: "注文価格",
        activitycoin: "活動貨幣",
        acceptcoin: "通貨を受け取る",
        holdcoin: "倉庫を持って通貨を要求する",
        limittimes: "個人限定購入回数",
        limitamount: "個人限定購入数量",
        unlimited: "限りない",
        alreadyamount: "購入済み数量",
        alreadyholdamount: "活動参加総括倉庫",
        myalreadyholdamount: "私の参加は倉庫を持ちます",
        leftamount: "残りの数量",
        attention: "注意",
        attentiontxt1: "1、'持ち倉分割','自由予約','雲鉱機予約','鎖倉',の活動に参加した後、資産を凍結し、活動が終わったら解凍または解除して釈放する",
        attentiontxt2: "2、'持ち倉分割','自由予約','雲鉱機予約','鎖倉',の活動に参加した後、ユーザーは申請を取り消すことができません",
        attentiontxt3: "3、プロジェクト側及びその他の不可抗力要素により活動をキャンセルした場合、元の道路を凍結資産に戻します",
        attentiontxt4: "* 本活動の最終説明権はBIPPAXの公式所有である",
        inputamount: "両替数量を入力します",
        inputholdamount: "ロックの数を入力します",
        mybalance: "私の利用可能残高",
        holdtips: "'持ち倉分割',の活動に参加するには、活動終了までロックします",
        pleaseinputamount: "両替数量を入力してください",
        pleaseinputholdamount: "ロック数量を入力してください",
        commitfailed: "参加の送信に失敗しました！",
        minlimitamountfailed: "両替数量は最低から両替量を下回ってはいけません！",
        maxlimitamountfailed: "両替数量は最大限度量を超えてはいけません！",
        limittimesfailed: "ご参加の回数が個人の上限回数を超えました！",
        balancenotenough: "残高が足りない！",
        headertitledesc: "投資家、プロジェクト側、取引所など多方面でウィンウィンの開放実験室",
        currentdivided: "現在の私の持ち場は分約できる",
        leveloneCount: "一級の友達数が必要です",
        submit: "送信",
        tipsmobile: "パソコンの画面に入って参加してください（www.BIPPAX.com）",
        tipsmobile1: "パソコンの端で開けてください（www.BIPPAX.com）そして革新実験区に入って参加します",
        intvalue: "整数を入力してください",
        inputminingamount: "購入鉱機数を入力します",
        moreactivity: "その他の活動",
        releaseType: "リリースのタイプ",
        releaseType0: "等額で釈放する",
        releaseType1: "等比釈放",
        lock: " 期限が切れる",
        releaseDetail: "リリースの詳細",
        lockday: " 日",
        lockweek: " 週間",
        lockmonth: " 月",
        lockyear: " 年",
        releasePercent: "比率を釈放する",
        lockFee: "ロックのしきい値",
        releaseTimes: "釈放倍数",
        times: "倍"
    },
    invite: {
        myinvitelink: "私の招待リンク",
        copy: "コピー",
        copyed: "コピーしました",
        mylevelone: "私の一級の友達",
        myleveltwo: "私の二級の友達",
        mycommission: "コミッション収入(換算するUSDT)",
        extrareward: "ボーナス",
        partnerlevel: "パートナーレベル",
        ruledetail: "ルールの詳細",
        ruleprofile1: "BIPPAX(www.bippaxcoins.com)の【パートナーを広める】ネットです",
        ruleprofile2: "返中率が一番高いです、",
        ruleprofile3: "返用時間が一番長いです(最高终身返佣)",
        ruleprofile4: "のプロモーション活動，相応の努力を払ったプロモーション者を本当の意味でのプラットフォームにすることができます。“パートナー”，享受とBIPPAX(www.bippaxcoins.com)取引プラットフォームの共同成長の配当金！具体的な細則は以下の通りである:",
        ruletext1: "一、デジタル資産の理念を布教し、ユーザー規模を拡大する，BIPPAX(www.bippaxcoins.com)売り出す【パートナーを広める】計画，この活動は長期有効です",
        ruletext2: "二、友達を誘って2級に分けます，AがBを招待するなら、BはAの一級の親友です,BがCを招待したら、CはBの一級の友達に属します,同時にAの二級の友達にも属します",
        ruletext3: "三、友達登録を広めるには、招待者からのリンクや招待者の招待コードを手動で入力することで招待者の一級の友達になります",
        ruletext4: "四、招待者は招待者招待コードで登録します，そして実名認証を完了したら，インセンティブを返すと効果があります",
        ruletext5: "五、還付期間は、招待された方が実名認証を完了してからNヶ月です，レベルによって違います，楽しみの戻り率が違います",
        ruletext6: "六、返佣資産を下級の親友貨幣の取引手数料として普及させ、返佣貨幣を三大市場の基礎貨幣とする,例:USDT、BTC、ETH",
        ruletext7: "七、帰佣比率を拡大し、帰用時に長与で一級の親しい人を普及させることによって、人数が多くなり、帰用率が高くなります。具体的に普及して還用する割合は以下の通りです:",
        ruletext8: "八、ポストランキングTOP 10またはTOP 100を押し広めると不定期にBIPPAXが獲得します(www.bippaxcoins.com)官給のボーナス",
        ruletext9: "九、他の活動や【パートナーを広める】活動が衝突した場合、協議した上で、臨時に変更するかどうかを決めます",
        ruletext10: "十、L4(巡撫する)、L5(太守)、L6(節度使)級パートナーはそれぞれ、年間還付総額の5%、10%、15%の配当奨励",
        ruletext11: "十一、本活動の最終解釈権はBIPPAXの所有である",
        ruleexampletitle: "例をあげて説明する:",
        ruleexamplecontent1: "もしユーザーの厳さんが一級の友達を100人招待したら、TAの一級の友達はそれぞれ5人の二級の友達を招待しました,この時、厳さんは100人の一級の友達を持っています。500人の二級の友達です。一人当たり一日3000元の取引をすれば、小厳月収は約:(100*3000*0.001*30% + 500*3000*0.001*10%) * 30 = 7200/月",
        ruleexamplecontent2: "もしユーザーの厳さんが1級の友達を1000人招待したら、TAの1級の友達はそれぞれ5人の2級の友達を招待しました,この時、厳さんは1級の友達を1000人持っています。5000人の2級の友達です。一人当たり一日3000元の取引をすれば、小厳月収は約:(1000*3000*0.001*50% + 5000*3000*0.001*20%) * 30 = 135000/月",
        lastupdate: "最後に更新",
        laststastic: "集計終了時間",
        level: "レベル",
        lv1: "里正",
        lv2: "県知事",
        lv3: "府を知る",
        lv4: "巡撫する",
        lv5: "太守",
        lv6: "節度使",
        levelonecount: "一級の友達数",
        levelonecommission: "一級の親友の還用割合 / 返用時間",
        leveltwocommission: "二級の親友の還用割合 / 返用時間",
        partnerdivide: "仲間が配当する",
        month: "ヶ月",
        alllife: "終身奉公にする",
        totalcommissionrank: "帰佣総額を押し広める",
        rank: "ランキング",
        userid: "ユーザID",
        rankday: "(日ランキング)",
        rankweek: "(週ランキング)",
        rankmonth: "(月ランキング)",
        rankall: "(总ランキング)",
        promotioncount: "人数を押し広める",
        commissionusdt: "奉公に帰る(換算するUSDT)",
        ranktip1: "招待人数は一級の友達数です，このランキングは還付総金額ランキングです",
        ranktip2: "招待人数は一級の友達数です，このランキングは1級の招待人数の順位です",
        thanks: "ありがとうございますBIPPAX(www.bippaxcoins.com)共に成長する！",
        headertip: "以上のコミッションのデータはリアルタイムで更新できません，システムは24 Hごとに統計して更新します",
        ptools: "ツールボックスを展開",
        pt_title: "デジタル通貨ギフトカード",
        pt_desc: "両替したら自動的に下級の友達になります，友達を送り、家族を送り、取引先を送り、仲間を送ります。協力してパートナーを押し広めることを助けます",
        pt_more: "もっと多くのものを期待してください",
        pt_tips: "もしあなたがいいアイデアを持っているなら，メールを送信してくださいpromotion@BIPPAX.com，採用後のご褒美がありますよ！",
        pt_card_amount: "カードの金額",
        pt_card_deadline: "有効期間",
        pt_card_noend: "無期限",
        pt_card_btn: "プロモーションパートナーは30枚無料です(約300ドルです)",
        pt_card_btn_login: "登録したら無料で30枚もらえます",
        pt_card_rule: "ルールの詳細",
        pt_card_summary: "デジタルマネーギフトカードは、パートナーをより良く誘うために開発されたプロモーションツールの一つです，対象ユーザーを押し広めてギフトカードを交換する場合，自動的にプロモーションの下線友達になります",
        pt_card_rule1: "一、無料ギフトカードは一人30枚までです。もっと多くのギフトカードを発行するなら、ユーザーが料金を払って注文して、カードの面の金額、LOGO、説明文などをカスタマイズすることができます。注文の注文はメールで送ってください",
        pt_card_rule2: "二、無料ギフトカードはお一人様1つに限ります。からBIPPAX(www.bippaxcoins.com)公式発行の無料ギフトカード，戸限ごとに一つずつ両替する，別のユーザーを通して、異なる両替コードの無料ギフトカードを受け取ってもいいです，1つだけ両替できます。ギフトカードのカスタマイズはこの限りではありません",
        pt_card_rule3: "三、ユーザーがギフトカードを交換する前に，存在しないなら“招待者”（つまりアカウント登録時に招待コードが入力されていません），自動的にカードを送る人の一級の友達に関連します。Aアカウント登録時に招待コードが入力されていない場合，この時Aは誰の一級または二級の親友ではありません,但し、AがB発行のギフトカードを通じて両替した後，Aは自動的にBの一級の友達になります",
        pt_card_rule4: "四、客を防ぐために，ギフトカードの帳簿金額はリアルタイムで支払うのではありません，受け取ったら実名認証を完了してから操作できます",
        pt_card_rule5: "五、無料ギフトカードを受け取る時は実名認証が必要です，両替時に実名認証を完了する必要がなくても受取りできます，これは普及者が早く部下の友達を獲得するためです",
        pt_card_rule6: "六、無料ギフトカードの最終解釈権は帰りますBIPPAX.PROすべて",
        pt_card_day: "毎日",
        pt_card_title_tips: "2000元を受け取って、補助金を押し広める",
        pt_card_receivew_success: "おめでとう！パートナーのギフトカードの受け取りに成功しました。！どうぞ【センター】->【カードセンター】表示！",
        usepromotion: "素材を広める",
        saveimage: "画像を保存",
        imagetips: "画像を正常にダウンロードできない場合，スクリーンショットツールでスクリーンショットを使って保存してください！",
        pt_invite_title: "招待登録の宣伝図",
        pt_invite_desc: "専用の二次元コード，QRコードで登録すると自動的に下位の友達になります，様々なグループまたはフォーラムで転送するのに適しています",
        colum_text0: "ランキング",
        colum_text1: "会員",
        colum_text2: "人数を押し広める",
        colum_text3: "奉公に帰る(換算するUSDT)",
        colum_text4: "ボーナス",
        context_title: "プロモーションパートナー専用の償還コード",
        context_title1: "スキャンして詳細を確認",
        context_title2: "私の招待コード",
        context_title3: "招待画像"
    },
    uc: {
        verify: "実名認証",
        login: {
            noaccount: 'アカウントがありません？',
            register: '登録する',
            login: 'ログイン',
            welcomelogin: 'ログインを歓迎します',
            usertip: '携帯番号かメールアドレスを入力してください',
            pwdtip: 'パスワードを入力してください',
            validatecodeload: '認証コードを読み込み中',
            validatemsg: '先に検証を完了してください',
            forget: 'パスワードを忘れます?',
            loginvalidate: 'アカウントを入力してください',
            pwdvalidate1: 'パスワードを入力してください',
            pwdvalidate2: 'パスワードの長さは6桁を下回ってはいけません',
            success: 'ログイン成功',
            goregister: "即時登録",
            getlostpwd: "パスワードを忘れます"
        },
        forget: {
            title: "パスワードを取得",
            hasaccount: 'アカウントがあります？ログインをクリックしてください',
            login: 'ログイン',
            sendcode: '認証コードを送信',
            newpwd: '新しいパスワードを入力してください',
            confirmpwd: 'パスワードを再確認してください',
            save: '送信',
            pwdvalidate1: '確認パスワードを入力してください',
            pwdvalidate2: '二回のパスワードの入力が一致していません!',
            resettelpwd: '携帯のパスワードをリセットします',
            resetemailpwd: 'メールのパスワードをリセット',
            newpwdtip: '新しいパスワードを入力してください',
            pwdvalidate3: 'パスワードの長さは6桁を下回ってはいけません',
            telno: '携帯の番号',
            mtelno: '携帯電話の認証',
            memail: 'メールボックス認証',
            smscode: '認証コードを入力してください',
            teltip: '携帯の番号を入力してください',
            smscodetip: 'メールの検証コードを入力してください',
            email: 'メールボックス',
            emailcode: 'メールアドレス',
            emailtip: 'メールボックスを入力してください',
            emailcodetip: 'メールの検証コードを入力してください',
            resetpwdsuccess: 'パスワードをリセットしました',
            smswarn: 'メッセージをチェックしてください',
        },
        finance: {
            center: '財務センター',
            personalassets: '貨幣口座',
            swapassets: '永続アカウント',
            billdetail: '資産流水',
            tradetail: '取引掘削',
            paydividends: 'は貨幣の配当を持ちます',
            invitingmining: '採掘奨励の招待',
            charge: '充幣',
            pickup: '提幣',
            fi1: ' 小額資産を隠す',
            money: {
                M1: '受領数量',
                M2: '転出数',
                M3: '為替レート',
                cointype: '貨幣名',
                balance: '利用可能資産',
                frozen: '凍結資産',
                operate: '操作',
                charge: '充幣',
                pickup: '提幣',
                onkeytrans: 'ワンタッチ',
                getaddres: 'は住所を取得します',
                reetsuccess: '取得成功',
                match: 'ペア',
                matchtip1: 'はGCXの数に対応できます',
                matchtip2: 'ペアの数を入力してください',
                matcher1: '有効な数量を入力してください！',
                matcher2: 'が最大ペアリング数を超えました！',
                matchsuccess: 'ペアリング成功！',
                needreleased: '未釈放資産',
                totalassets: "総資産換算:",
            },
            swap: {
                totalassets: '口座権益折合:',
                swap: '継続口座',
                swaptype: '契約口座',
                swapassets: '口座の権益',
                avabalance: '利用可能保証金',
                usebalance: '使用済み保証金',
                frozenbalance: '凍結保証金',
                profitandloss: '損益が実現されていない',
                transfor: '資金振り替え',
                inputtransferamount: '振替数量',
                all: '全部回転',
                currencyaccount: '貨幣口座',
                swapaccount: '継続契約口座',
                clickchange: 'クリックして方向転換',
                avaamount: '回転可能限度額',
                pleaseselectwallet: '先に口座への転入/転出を選択してください',
                pleaseinputamount: '划转数を入力してください',
                oktransfer: '振り替え確認',
            },
            record: {
                Please: '日付範囲を選択してください',
                start_end: '起止時間',
                to: '至',
                operatetype: '操作タイプ',
                search: '検索',
                charge: 'チャージ',
                pickup: '提現',
                transaccount: '振替',
                exchange: '貨幣取引',
                otcbuy: 'フランス円買い',
                otcsell: 'フランス円売り',
                activityaward: '活動奨励',
                promotionaward: 'プロモーション奨励',
                dividend: '配当',
                vote: '投票',
                handrecharge: '人工チャージ',
                match: 'ペア',
                activitybuy: '活動両替',
                ctcbuy: 'CTC購入',
                ctcsell: 'CTC販売',
                redout: "お年玉",
                redin: "祝儀をもらう",
                chargetime: '取引時間',
                type: 'タイプ',
                fee: '手数料',
                shouldfee: '買掛手数料',
                revenue: '収支タイプ',
                re1: '入金',
                re2: '出金',
                discountfee: '差し引き手数料',
                realfee: '実付手数料',
                symbol: '貨幣',
                num: '数量',
                status: '状態',
                finish: 'は完了しました',
                quickExchange: "フラッシュ",
                currentRate: "現在の為替レート",
                from: "から",
                inputexchangeamount: 'フラッシュ入力数',
                inputexchangepasswd: '取引パスワードを入力',
                chooseTransCoinUnit: '貨幣転化選択',
                inputTransAmount: '入力変換数',
                predictAmount: '数量で両替できる予定',
                qamount: 'フラッシュの数',
                qrate: '為替レート',
                qexamount: '両替数量',
                withdrawcodein: '貨幣コードチャージ',
                withdrawcodeout: '貨幣コード引換',
                contractfee: '契約継続手数料',
                contractprofit: '継続契約の利益',
                contractloss: '継続契約損失',
                optionfail: '予測契約の失敗',
                optionfee: '予測契約手数料',
                optionreward: '予測契約ボーナス',
                other: 'その他',
            },
            paydividende: {
                money_holding: '手持ち貨幣の配当は累計（ETH）に戻りました:',
                money_hold: '手持ち貨幣の配当は累計（ETH）を返します',
                paydividends: '貨幣を持って配当をする(ETH)',
                account_date: 'が会計の時間になります',
                datehodld: '手持ち貨幣の日付',
                start_end: '起止時間',
                to: '至',
                operatetype: '操作タイプ',
                search: '検索',
                charge: 'チャージ',
                pickup: '提現',
                transaccount: '振替',
                exchange: '貨幣取引',
                otcbuy: 'フランス円買い',
                otcsell: 'フランス円売り',
                activityaward: '活動奨励',
                promotionaward: 'プロモーション奨励',
                dividend: '配当',
                vote: '投票',
                handrecharge: '人工チャージ',
                match: 'ペア',
                chargetime: '取引時間',
                type: 'タイプ',
                fee: '手数料',
                symbol: '貨幣',
                num: '数量',
                status: '状態',
                finish: '完了しました',
            },
            trade: {
                start_end: '起止時間',
                account_date: 'が会計の時間になります',
                to: '至',
                operatetype: '操作タイプ',
                search: '検索',
                charge: 'チャージ',
                pickup: '提現',
                transaccount: '振替',
                exchange: '貨幣取引',
                otcbuy: 'フランス円買い',
                otcsell: 'フランス円売り',
                activityaward: '活動奨励',
                promotionaward: 'プロモーション奨励',
                dividend: '配当',
                vote: '投票する',
                handrecharge: '人工チャージ',
                match: 'ペア',
                chargetime: '注文生成時間',
                type: 'タイプ',
                fee: '掘削手数料返還(BHB)',
                num: '数量',
                status: '状態',
                finish: 'は完了しました',
                transactionTime: '取引時間',
                symbol: '取引ペア',
                direction: '取引の方向',
                price: '価格',
                entrustment: '委託量',
                havedeal: 'はすでに成約しました',
                poundageAmount: '手数料',
                exchangeOrderId: '注文ID',
                mineAmount: '貨幣数（BHB）',
                buy: '購入',
                sell: '販売',
                limit: '価格制限',
                market: '市価',
                clear: 'クリア条件',
                turnover: '取引金額',
            },
            recharge: {
                recharge: '充幣',
                symbol: '貨幣',
                address: 'チャージアドレス',
                copy: '複製',
                qrcode: '二次元コード',
                qrcodeaddress: 'チャージアドレス二次元コード',
                msg1: '上記の住所に通貨以外の資産をチャージしないでください。でないと、資産は探し出せません',
                msg2: '上記アドレスにチャージした後、ブロックチェーンネットワークノード全体の確認が必要です。一般ブロックチェーンのメインネットワークは3回確認してから入金します',
                msg3: '最小チャージ金額:',
                msg3_1: '最小金額より小さいチャージは入金されません',
                msgtop: 'このアドレスはUSDTのチャージにのみ使用できます',
                msg4: 'あなたのチャージアドレスは常に変更されません。繰り返しチャージできます。変更があれば、できるだけウェブサイトを通じてお知らせします',
                msg5: 'パソコンやブラウザの安全を確認し、情報の改竄や漏洩を防止してください',
                record: 'チャージ記録',
                copysuccess: 'コピー成功！',
                copyerr: 'コピーに失敗しました！手動でコピーしてください',
                time: '到着時間',
                amount: 'チャージ数量',
                gettingaddress: 'チャージアドレスを取得します,少々お待ちください',
                getaddress: 'チャージアドレスの取得',
                memotips: 'チャージする時は要求通りにこのMemoを入力してください。資産をなくします',
                withdrawrecharge: 'トークンチャージ',
                coderechargetip: "トークンコードを入力してください",
                rechargesuccess: 'おめでとうございます。お札のチャージに成功しました',
                rechargeconfirm: 'チャージ確認',
                status: '状態',
            },
            withdraw: {
                pickup: '提幣',
                addressmanager: 'お札の住所管理',
                withdrawbycode: '提幣コード提幣',
                withdrawcode: 'トークンコード',
                symbol: '貨幣',
                address: '提幣住所',
                num: 'お札の数',
                avabalance: '利用可能残高',
                msg1: '提幣の数が低い',
                msg2: 'は自動的に入金されます。そうでなければ、人工審査が必要です',
                increase: '引き上げ限度額',
                tip1: '最大入力',
                tip11: 'ビット小数、最小値は',
                tip2: '最大値は',
                numtip1: 'は貨幣の数を入力します',
                fee: '手数料',
                range: '範囲',
                arriamount: '入金数量',
                msg3: '最小貨幣数は',
                msg4: '貨幣',
                msg5: '資金の安全を保障するために、口座のセキュリティポリシーが変更され、パスワードが修正され、新しい住所でお金を引き出します。お金を引き出して人工審査を行います。スタッフの電話やメールの連絡を待ってください',
                msg6: 'パソコンやブラウザの安全を確認し、情報の改竄や漏洩を防止してください',
                record: 'デポジット記録',
                symboltip: '貨幣を選んでください',
                addresstip: '住所を記入してください',
                numtip2: '正しい貨幣引き出しの数量を記入してください。最小値は',
                numtip3: '貨幣引換数量は手数料より小さくてはいけません',
                amounttip: 'は貨幣の引き出し数を入力してください',
                feetip1: '手数料の最小値は',
                feetip2: '最大値は',
                time: '提現時間',
                status: '状態',
                status_1: '審査中',
                status_2: '振替中',
                status_3: '失敗',
                status_4: '成功',
                St5: '強平価を見積もる',
                St6: '総資産＝財布残高＋未実現',
                St7: '損益未実現＝すべての持倉契約が最新価格で算出した未実現損益',
                St8: '財布残高＝転入−転出−損益実現済み',
                St9: '拒否しました',
                remark: '備考',
                add: '追加',
                addresslist: 'アドレスリスト',
                safevalidate: '安全検証',
                telno: '携帯番号',
                smscode: '携帯の認証コード',
                second: '秒',
                clickget: 'をクリックして取得',
                email: 'メールボックス',
                emailcode: 'メール検証コード',
                save: '保存',
                delete: '削除',
                telerr: '携帯番号が正しくないです',
                emailerr: 'メールアドレスが間違っています',
                codeerr: '検証コードが正しくない',
                remarktip: 'コメントを入力してください',
                savemsg1: '保存に失敗しました！',
                savemsg2: '保存成功！',
                operate: '操作',
                fundpwdtip: '資金コードを入力してください',
                click: 'クリック',
                filtrate: '選別可能',
                txid: "TxId",
                generateCode: 'トークンコードの生成',
                withdrawcodelist: '貨幣コードリスト',
                withdrawcodestatus: '状態',
                submit: '提出',
                generatecodesuccess: '提現コード生成成功',
                wi1: 'ネットワーク ',
                wi2: 'セキュリティ認証',
                wi3: '受領金額 ',
                wi4: '受領アドレス',
                wi5: ' 引き出しネットワーク',
                wi6: ' 引き出し総額',
                wi7: 'ネットワーク手数料',
                wi8: '正しい引き出しアドレスを入力し、選択した引き出しネットワークがアドレスと一致していることを確認してください。',
                wi9: '引き出し注文は作成後キャンセルすることはできません。',
                wi10: '続ける ',
                wi11: '資金パスワード',
                wi12: ' 携帯電話の認証コード',
                wi13: '認証を送信 ',
                wi14: 'メールの認証コード ',
                wi15: '認証を送信 ',
                wi16: '送信',
            }
        },
        member: {
            usercenter: '個人中心',
            securitycenter: '安全センター',
            securitysetting: '安全設定',
            accountsetting: '入金方式',
            account: 'アカウント管理',
            assets: '資金管理',
            exchange: '取引管理',
            curdelegate: '当日注文',
            hisdelegate: '歴史依頼',
            otc: 'OTC管理',
        },
        order: {
            ordercenter: 'オーダーセンター',
            myorder: '私の注文',
            myad: '私の広告'
        },
        regist: {
            Res1: 'ユーザー名は大文字と小文字の英数字で構成され、英字を含む必要があります',
            hasaccount: 'アカウントがありますか？ログインをクリックしてください',
            login: 'ログイン',
            username: 'ユーザー名',
            country: '国家',
            smscode: 'ショートメッセージの検証コード',
            sendcode: '送信検証コード',
            resendcode: '再送信(',
            pwd: 'ログインパスワード',
            repwd: 'パスワード確認',
            confrimpwd: 'パスワードの確認',
            agreement: 'はすでに読んで同意しました',
            userprotocol: 'ユーザープロトコル',
            regist: '登録',
            teltip: '携帯の番号を入力してください',
            telerr: '携帯電話番号のフォーマットが正しくないので、もう一度入力してください',
            emailtip: 'メールボックスを入力してください',
            emailerr: 'メールボックスのフォーマットが間違っています,再入力してください',
            confirmpwdtip: '確認パスワードを入力してください',
            confirmpwderr: '2回のパスワードの入力が一致しません',
            telregist: '電話登録',
            emailregist: 'メールアドレス登録',
            usernametip: 'ユーザ名を入力してください',
            usernamemsg: 'ユーザー名の長さは3桁より少なくてはいけません。15桁より多いです',
            countrytip: '国を選んでください',
            smscodetip: 'ショートメッセージの検証コードを入力してください',
            pwdtip: 'ログインパスワードを入力してください',
            pwdmsg: 'パスワードの長さは6桁を下回ってはいけません',
            telno: '携帯番号',
            email: 'メールアドレス',
            agreementtip: '同意をクリックしてください',
            modaltitle: 'を確認してください',
            promotion: '招待コード',
            singapore: 'シンガポール',
            china: '中国',
            korea: '韓国',
            japan: '日本',
            thailand: 'タイ',
            russia: 'ロシア',
            uk: 'イギリス',
            vietnam: 'ベトナム',
            india: 'インド',
            italy: 'イタリア',
            hk: '香港',
            malaysia: 'マレーシア',
            taiwan: '台湾省',
            turkey: '七面鳥',
            germany: 'ドイツ',
            france: 'フランス',
            spain: 'スペイン',
            us: 'American',
        },
        safe: {
            Ad1: '社会保障カード、免許証、パスポートをアップロードしてください',
            Ad2: '送信する前にファイルの1つをアップロードする',
            Ad3: 'フルネーム',
            Ad4: '連絡先',
            Ad5: '生放送',
            Ad6: '私の生放送',
            Ad7: '追加に失敗しました。最大3つしか追加できません',
            size: 'アップロード画像のサイズは5 Mを超えてはいけません',
            safelevel_low: 'セキュリティレベル:低い',
            safelevel_high: 'セキュリティレベル:高さ',
            safelevel_medium: 'セキュリティレベル:にある',
            nickname: 'ニックネーム',
            bind: '結合',
            binded: '紐付け済み',
            binding: '審査中',
            binderr: '失敗',
            bindretry: '再試行',
            verifypass: "認証済み",
            verified: '実名認証',
            notverified: "認証なし",
            verifiedtip: 'あなたの口座の安全を保障するために，実名認証を完了してから、取引操作ができます！',
            realname: '実名',
            idcard: '身分証番号',
            upload: 'クリックしてアップロード',
            upload_positive: '身分証の正面写真',
            upload_negative: '身分証の裏写真',
            upload_hand: '身分証と個人の署名写真を持っています',
            save: '保存',
            reset: 'リセット',
            email: 'メールボックス',
            bindemail: 'メールアドレスを紐づける',
            loginpwd: 'ログインパスワード',
            emailcode: 'メールアドレス',
            clickget: 'クリックして取得',
            second: '秒',
            phone: '携帯電話',
            bindphone: '携帯を結び付ける',
            phonecode: '携帯の認証コード',
            logintip: 'プラットフォーム登録時に使用する',
            edit: '変更',
            oldpwd: '元のログインパスワード',
            newpwd: '新規ログインパスワード',
            confirmnewpwd: '新しいパスワードを確認します',
            fundpwd: '资金密码',
            fundtip: '口座資金の変動時，まず資金のパスワードを検証する必要があります',
            set: '設定',
            confirmpwd: 'パスワードを確認する',
            oldfundpwd: '元の資金コード',
            newfundpwd: '新しい資金のパスワード',
            newpwdmsg1: '6桁以内の新規登録パスワードを入力してください',
            newpwdmsg2: '新規登録パスワードが一致しません',
            pwdmsg1: '6桁以下のパスワードを入力してください',
            pwdmsg2: 'パスワードが一致しません',
            emailtip: 'メールアドレスを入力してください',
            codetip: '認証コードを入力してください',
            telnotip: '携帯の番号を入力してください',
            oldpwdtip: '元のパスワードを入力してください',
            realnametip: '実名を入力してください',
            idcardtip: '身分証番号を入力してください',
            bindphonetip: 'まず携帯電話と結びつけてください!',
            resetfundpwd: '資金のパスワードをリセット',
            upload_positivetip: '身分証の正面写真をアップロードしてください',
            upload_negativetip: '身分証の裏写真をアップロードしてください',
            upload_handtip: '手持ちのIDカードをアップロードしてください',
            save_success: '保存に成功しました!',
            save_failure: '保存に失敗しました!',
            idcard_verifymsg1: "1、JPG、PNGフォーマットをサポートしています。ファイルは8 Mより小さいです。証明書の情報は、はっきりと見えます。変更とブロックは一切許されません。証明書番号と名前がよく見えなければなりません",
            idcard_verifymsg2: "2、写真は無冠で、化粧していないことを提案して、証明書を持つ人の顔立ちははっきりしていて、完全に腕を現します",
            idcard_verifymsg3: "3、同時に証明書と手書きの文案（氏名＋申請日）を持ちます。私は当駅でのすべての行為は本人のために行います",
        },
        account: {
            pagetitle: '実名アカウントをバインドする',
            pagetip: 'お支払い方法を設定してください,必ず本人の実名アカウントを使ってください',
            backcardno: '銀行カードのアカウント',
            backcardtip: '個人銀行カードの情報は紐付けられていません',
            modify: '変更',
            bind: '結合',
            name: '名前',
            bankaccount: '銀行を開く',
            bankbranch: '銀行を開設する',
            bankno: '銀行カード番号',
            confirmbankno: 'カード番号を確認する',
            fundpwd: '資金コード',
            save: '保存',
            zfbaccount: 'アリペイアカウントを支払う',
            zfbaccounttip: '個人のアリペイ口座は紐付けられていません',
            wxaccount: 'WeChatアカウント',
            wxaccounttip: '個人のWeChatアカウントはバインディングされていません',
            banknomsg1: '正しい銀行カード番号を入力してください',
            banknomsg2: '二回入力した銀行のカード番号が一致しません',
            verifiedmsg: 'まず実名認証を行ってください',
            bankaccountmsg: '口座開設銀行を選んでください',
            bankbranchmsg: '口座開設支店を入力してください',
            banknomsg: '正しい銀行カード番号を入力してください',
            fundpwdmsg1: '正しい資金コードを入力してください',
            fundpwdmsg2: 'パスワードは6文字以下であってはいけません',
            zfbaccountmsg: 'アリペイアカウントを入力してください',
            wxaccountmsg: 'WeChatアカウントを入力してください',
            save_success: '保存に成功しました!',
            save_failure: '保存に失敗しました!',
            imgtip: 'あなたの入金コードをアップロードしてください',
        },
        otcorder: {
            unpaid: '未払い',
            paided: 'はすでに支払いました',
            finished: 'は完了しました',
            canceled: 'キャンセルしました',
            appealing: '訴え中',
            searchtip: '注文番号を入力して検索を開始する',
            orderno: '注文番号',
            created: '作成時間',
            symbol: '取引通貨',
            type: '取引の種類',
            type_sell: 'が売れます',
            type_buy: '買取',
            tradename: '取引先',
            amount: '数量',
            money: '金額',
            fee: '手数料'
        },
        identity: {
            certified: '認証済み',
            placeholder: 'キャンセルの原因を記入してください',
            apply: '事業者になる申請',
            become: 'BIPPAX認証事業者になり、より多くの取引特権を享受する',
            zhusnhu: '事業者は独自の広告ブースを有し、取引の成功率を高める',
            tijiaoziliao: '事業者認証資料の提出',
            place: '用意した事業者認証資料をプラットフォームにアップロードして提出してください',
            tijiao: 'あなたの事業者認証の審査が提出されました。',
            tijiaosuc: 'おめでとうございます。あなたの事業者認証審査が通過しました',
            tijiaofail: "すみません！あなたの事業者認証の審査が通っていません",
            zhuxiaotijiao: 'あなたの事業者抹消申請はすでに提出されました。',
            shenhefail: 'あなたの事業者の取り消し申請審査が通っていません。',
            shenhesuc: 'お客様の事業者抹消申請審査が通過しました。',
            shangjiazhuxiao: '事業者抹消',
            shenheshibai: '審査失敗',
            shenagain: '再審査',
            sheqinggain: '再申請',
            reason: '原因',
            shenqingtuibao: '解保申請',
            getquan: '以下の権限を持つ',
            read: 'すでに読んで同意しました。',
            lijishenqing: '即時申請',
            tips: 'ヒント',
            wufachexiao: '事業体の取消作業を行っていますが、申請操作を確認したら取り消されません。',
            suredo: 'この操作を実行することを確認しますか？',
            shuzizichan: 'デジタル資産取引証明書',
            gerenzichan: '個人デジタル資産証明',
            second: {
                line: 'どうやって事業者になることを申請しますか？',
                step1: '第一歩: 要求通りに事業者申請資料を準備する',
                step1c1: '次の申請資料を準備します。',
                step1c2: '携帯番号、マイクロ信号、QQ番号、個人デジタル資産証明（写真）、デジタル資産取引証明（写真）',
                step2: '第二ステップ: 申請の提出',
                step2c: '記入とアップロードが必要な事業者認証審査資料を作成し、クリックして審査に提出する',
                step3: '第三ステップ: 資料審査',
                stepc: '3-5営業日以内にお宅の企業申請資料を審査します。いつでも審査状態に注目してください。提出ページで確認できます。審査が通過したら、仏貨取引エリアで広告を発表することができます',
                agree: '凍結同意',
                agreec: '事業者保証金として',
                shenqingchngweishangjia: '事業者になる申請',
            },
            yuanyin: '原因',
            tijiaoshenqing: '提出申請',
            bizhong: '保証金貨種',
            shuliang: '保証金の数',
            chosen: '貨幣を選ぶ',
            seat: '専属ブース',
            service: '一対一サービス',
            lowfee: 'より低い手数料',
            phone: '携帯電話',
            balance: '個人資産状況',
            cardphoto: '身分証の正反対写真',
            wx: 'WeChat',
            exchange: 'デジタル資産の場外取引に従事したことがありますか？',
            handphoto: 'ユーザーが身分証の写真を持っています',
            qq: 'QQ',
            ploy: 'は対応する風制御戦略があるかどうか',
            agreement: '《認証事業者協議》',
            applyfor: '確認申請',
            sendcode: '送信検証コード',
            confirm: '確定',
            prepare: '資料を準備する',
            review: '提出審査',
            result: '結果を待つ',
            passed: '審査通過',
            approve: '事業者協議を認証してください',
            emailtip1: '下記の書類をメールで送ってください',
            emailtip2: 'できるだけ早く申請の審査を行います',
        },
        extension: {
            title1: 'リンクの普及',
            title2: '友人の紹介',
            title3: '私のコミッション',
            linkdesc: '以下のURLは外部に普及する住所です,友達、QQ、微信、微博、ブログ、フォーラムまたは自分のウェブサイトを通じて普及できます。この住所を通じて訪問したすべての人は登録してからあなたのユーザーに属します,これらのユーザーが当駅で策略を提出する時、コミッションを獲得できます。詳しい普及状況は訪問記録で調べられます,見ます',
            linktitle: 'あなたのプロモーションリンク',
            copy: '複製',
            copy_msg1: 'コピー成功！',
            copy_msg2: 'コピー失敗！手動でコピーしてください',
            username: 'ユーザー名',
            currrecharge: '現在の取引',
            userlevel: '推奨レベル',
            createdtime: '登録時間',
            currcommission: '当面のマージン',
            managerfee: '管理費',
            yuan: '元',
            smbol: '貨幣',
            amount: '金額',
            remark: '備考',
            amounttime: '発行時間',
        },
        promotion: {
            title: '私のプロモーション',
            subtitle1: '私のプロモーションカード',
            subtitle2: '両替記録',
            subtitle3: '私の招待',
            card_column0: '両替',
            card_column1: 'カード名',
            card_column2: 'カルメン貨幣',
            card_column3: 'カードの金額',
            card_column4: '有効期間',
            card_column5: '総数',
            card_column6: 'すでに両替しました',
            card_column7: '受領時間',
            my_column0: 'ユーザを招待する',
            my_column1: '登録時間',
            my_column2: '実名状態',
            gopromotion: '素材のプロモーション',
            inputcardno: '両替コードを入力してください',
            exchange: 'すぐ両替',
            exchangesuccess: '両替成功！資産管理に行って残高を調べてください',
            exchangewithcode: '両替',
        },
        activity: {
            navTitle: '革新管理',
            subNavTitle1: '参加しました',
            subNavTitle2: 'マイニングマシン',
            subNavTitle3: '私の鍵',
            column1: '名称',
            column2: 'タイプ',
            column3: '予約数量',
            column4: '貨幣に参与する',
            column5: '発注先',
            column6: '現在の状態',
            column7: '成約額',
            column8: '作成時間',
            mColumn1: '鉱機',
            mColumn2: '名称',
            mColumn3: '貨幣',
            mColumn4: '周期',
            mColumn5: '日数',
            mColumn6: '掘った',
            mColumn7: '状態',
            mColumn8: '基礎生産能力',
            mColumn9: '現在の生産能力',
            mColumn10: '総生産',
            mColumn11: '終了日',
            mColumn12: '作成日',
            lColumn1: '鎖倉',
            lColumn2: '名称',
            lColumn3: '貨幣',
            lColumn4: '周期',
            lColumn5: '日数',
            lColumn6: '解放済み',
            lColumn7: '状態',
            lColumn8: '基礎的生産能力',
            lColumn9: '現在の生産能力',
            lColumn10: '総生産',
            lColumn11: '終了日',
            lColumn12: '作成日',
        },
        mining: {
            title: 'マイコンリスト',
            empty: 'まだ鉱機がない',
            day: '天',
            week: '周',
            month: '月',
            year: '年',
            invitetip1: '本鉱機の生産能力は、友人を誘って向上させることができます。1人ずつ鉱山機を両替して、生産能力を向上させます。',
            invitetip2: '%，生産能力の上限を上げる',
            miningUnit: '貨幣を産出する',
            miningPeriod: '産出周期',
            miningDays: '採掘時間',
            miningedDays: '時間は掘っています。',
            miningDaysProfit: '基礎生産能力',
            miningCurrentDaysProfit: '実際の生産能力',
            status0: '配置待ち',
            status1: '配置済み',
            status2: 'もう終わりました',
        },
        locked: {
            title: '私のロックリスト',
            empty: 'ロックなし',
            day: '天',
            week: '周',
            month: '月',
            year: '年',
            invitetip1: '本鎖倉生産能力は友達を誘って向上させ、一人ずつロックに参加して、生産能力を向上させることができます。',
            invitetip2: '%，生産能力の上限を上げる',
            miningUnit: '貨幣を釈放する',
            miningPeriod: 'リリースサイクル',
            miningDays: '総放出周期',
            miningedDays: 'リリースサイクル',
            miningDaysProfit: 'ベースリリース',
            miningCurrentDaysProfit: '実際に釈放する',
            status0: 'リリース待ち',
            status1: 'リリース中',
            status2: 'もう終わりました',
            totallocked: '総ロック',
        }
    },
    cms: {
        noticecenter: '公告センター',
        newshelp: '新人ヘルプ',
        appdownload: 'APPダウンロード',
        onlineservice: 'オンラインサービス',
        faq: 'よくある問題',
        notice: '公告',
        servicecenter: '顧客サービスセンター',
        about: 'については、',
        joinus: '私たちに参加します',
        aboutus: '私たちについて',
        exchangerule: '取引規則',
        useprotocol: '使用プロトコル',
        feenote: '料金説明',
        merchantprocotol: '事業者協議',
        features: 'プラットフォームの特色',
        contactus: '連絡します',
        noticelist: '公告リスト',
        nextnotice: '次の編',
        prevnotice: '前編',
        notexist: "あなたの訪問の公告は存在しませんか？削除されました",
        otherhelp: 'このグループ内の文章',
        scanforshare: '掃除してシェアする',
        download: '即時ダウンロード',
        downloadslogan: "BIPPAXAPP - グローバルデジタル資産取引プラットフォーム"
    },
    description: {
        // message1: 'SSL、动态身份验证等银行级别安全技术，\n保障交易安全；支持多种数字货币交易',
        // message2: '严格的项目准入门槛，确保平台用户利益；\n100%保证金，钱包冷热隔离，确保用户资金安全',
        // message3: 'BIPPAX数字资产交易平台支持每秒1000笔交易，给用户带来酣畅淋漓\n的交易体验',
        title1: '金融級安全',
        title2: '急速充電',
        title3: 'グローバルサービス',
        title4: '厳選資産',
        message1: '全方位金融風制御システムと盗難防止システム、冷熱財布、多署名システムは資金の安全を保証します',
        message2: 'チャージして今最も速い3分完成して、24 H人工オンライン審査、取引先を保護して最も良い投資の機会を逃さないでください',
        message3: '全世界の業務サービスネットワークをカバーし、全世界の暗号化資産に投資し、全世界のユーザーと取引することを助けます',
        message4: '品質の高い暗号化項目を厳選し、80%の極めて危険なプロジェクトをフィルタします',
        message5: 'BIPPAX(www.bippaxcoins.com)国際デジタル暗号化資産取引プラットフォームの携帯電話のクライアントは、トランザクション体験に専念します',
        scanqrcode: "二次元コードをスキャン，ダウンロードAPP",
        aboutdesc1: "BIPPAX(www.bippaxcoins.com)技術世界トップのデジタル資産取引プラットフォームであり、ケイマン諸島に登録され、核心運営チームは香港にあります。BIPPAX(www.bippaxcoins.com)コアメンバーはトップクラスのインターネットと金融会社から来ています，ほとんどのメンバーは深ビットコインとブロックチェーン信奉者です，ブロックチェーンは伝統的な独占金融システムを変え、より民主的、自治的な社会構造を構築すると確信しています",
        aboutdesc2: "BIPPAX(www.bippaxcoins.com)プラットフォームは専門金融レベルの取引構造を持っています，自主的に開発した高合併メモリを持っております，プラットフォームは全冷チャージウォレットシステムを採用しています+複数の署名+高防護DDOS攻撃システムなどの取引アーキテクチャ，お客様の資産安全を保証します",
        aboutdesc3: "BIPPAX(www.bippaxcoins.com)お客様が投資機会をよりよく把握するために，顧客サービス部門内部は平準化管理を採用する，極速サービス応答機構を確立しました，資産顧客サービスマネージャーは長年7*24 Hオンラインで働いています，お客様に資産のチャージ、現金引換などのサービスを提供します，お客様が25分以内に資産のチャージを完了することを保障します",
        aboutdesc4: "BIPPAX(www.bippaxcoins.com)品質項目を厳選し、安全で安定した資産管理サービスを提供する。BIPPAX(www.bippaxcoins.com)'誠実、公正、情熱、開放',という理念を受け継ぎ、ユーザーのために、安全、信頼、高効率、友好の極致の取引所を作り上げる",
        aboutdesc5: "デジタル資産は今は小さな枠の中にしかいませんが、このような一人一人が完全に把握できる資産は未来にきっと流行ってくると信じています。一緒に努力して期待しています！",
        support: '技術サポート',
        report: '苦情の提案',
        service: '顧客サービス',
        apply: 'お札の申し込み',
        coop: 'ビジネス提携',
        community: 'BIPPAXコミュニティ',
        wechat: 'WeChat',
        addwechat: 'bizzzan01,を微信の友達として追加し,微信福利社群に入る',
        weibo: '微博',
        twitter: 'ツイッター',
        biyong: '貨幣用',
        telegram: '電報',
        medium: 'Medium',
        reddit: 'Reddit',
    },
    bzb_description: {
        title1: '配当権',
        title2: '手数料割引',
        title3: '優先予約',
        title4: '投票権',
        title5: '第一知る権利',
        title6: '優先的に貨幣に乗る',
        title7: '意思決定を協議する',
        title8: 'もっと',
        desc1: '手数料配当、収益配当、前貨幣配当、株式配当など',
        desc2: '取引手数料の最大80%割引返還奨励、詳細は未定',
        desc3: 'IEO初回及びBoot販促Token優先予約権',
        desc4: 'BIPPAXコミュニティの投票活動に参加し、前金、買戻しなどを含むが、それに限らない',
        desc5: '保有量が一定数に達してSVIPグループに入り、大きなVゼロ距離に接触する',
        desc6: 'スーパーノードに限り、推奨通貨資格を持つ',
        desc7: 'スーパーノードに限定し、共同で重大な決定権を持つ',
        desc8: 'より多くの権益を期待してください',
    },
    footer: {
        wechatkefu: 'WeChatカスタマーサービス',
        notice: 'プラットフォーム公告',
        changjian: 'よくある問題',
        shiyong: '使用合意',
        feilv: '料率説明',
        lianxi: '連絡メールボックス',
        biyong: '貨幣用',
        gsmc: 'グローバル優良デジタル資産を厳選し',
        bah: '沪ICP备13026899号-3',
        gsjj: 'について',
        gywm: '私たちについて',
        jrwm: '私たちに参加します',
        lxwm: '連絡してください',
        yqlj: '友情リンク',
        bzzx: 'ヘルプセンター',
        xsrm: '新米教程',
        czzn: 'チャージガイド',
        ptsm: 'プラットフォーム説明',
        fysm: '取引規則',
        fwtk: 'ユーザプロトコル',
        fltk: '料金説明',
        wechat: 'WeChatカスタマーサービス',
        xszn: '初心者ガイド',
        cjwt: 'よくある問題',
        mztk: '免責条項',
        ystk: 'プライバシー条項',
        tkxy: '条項協議',
        gybzb: 'BZBについて',
        kfyx: 'カスタマーメールボックス',
        swhz: 'ビジネス協力',
        sbsq: '上貨申請',
        jyzn: '取引マニュアル',
        bzzl: '通貨資料',
        tsjb: '苦情通報',
        apidoc: 'APIインターフェース',
        zwkf: '未開放',
    },
    index: {
        circulation: 'BHB安全と発展基金流通量',
        hourEth: '今日の未分配収入の累計換算',
        yesterdayEth: '昨日分配収入累計換算',
        yesterday: '昨日鉱山を掘って産出しました',
        bhbTotal: 'BHB総流束',
        bhbSecond: 'BHB二級市場流通量',
        checkMineprinciple: '採掘原理を確認する',
        checkFlowVolum: '検査流通量説明',
        checkLockPosition: 'ロック状況を確認する',
        BHBregister: 'BIPPAXアカウント登録',
        tibi: 'お引き出しの時間と限度額',
        line_plane: 'BHBオンライン計画、流通量及び手数料返還公告',
        fenpeijizhi: 'BIPPAXの収入分配メカニズムについての説明',
        jiangli_jihua: '採掘奨励計画の招待',
        friend_fanhuan: '友達を誘って、追加の手数料を取って返します',
    },
    plate: {
        title: "プラットフォーム収入配分方案 (BHB所有者持分)",
        content1: "白書が書いたように，BIPPAXはプラットフォームの80%を取り出します (税金を差し引いた後) の収入はBIPPAXの所有者に割り当てられ,20%の収入はプラットフォームの研究開発と運営をサポートするために使われます",
        content2: "収入の分配は日を一つの分配周期とする,2018年6月6日をはじめとする割当日。その後の毎日，前日に累積したすべての未分配収入を，一回限りの割合でBHB所有者に分け与える",
        content3: "（注:1.ここのBHBはリリースされたものだけを指します/流通可能なBHB，具体的には【",
        content3_1: 'BHB流通量について/収入分配比率の説明に参与する',
        content3_2: "2.毎時間（ジャストポイント）スナップショットと計算します，収入分配は一日に一回行われる）",
        hourFenpei: "今日の分配収入は折衷した",
        hourTotal: '今日のプラットフォームの総収入は折衷しました',
        xiangqing: '今日の収入分配の詳細',
        yesterdaytit: "昨日の天賦収入が折衷した",
        yesterdaytotal: "昨日のプラットフォームの総収入は折衷しました",
        yesterdayxiangqing: "昨日の収入分配の詳細",
        /*yesterday:{
          total:"平台总手续费",
          allocated:"待分配收入",
        }*/
    },
    feereturn: {
        ruletitle: "返却規則",
        rulecontent: "白書ではすでにBHBの分配比率について詳しく説明しています。51%比率のBHBを通過する“取引は鉱を掘る”の方式で取引ユーザーにフィードバックします。51%のBHBを全部フィードバックしたら完成です,“鉱を掘る”自動終了",
        recordtitle: '記録を返す',
        recordcontent: '毎日（UTC+8，以下同）前の日の利用者による取引手数料が発生します，100%BHBに換算してユーザーに返却する，換算価格は前の取引日のBHBの平均価格による（平均価格の計算方式は総成約金額です/総出来高）。私たちは毎日午前11時に出発します，発行開始前日の取引手数料はBHBの返却に換算します',
        /*time:"日期",
        todaycharge:"当日BIPPAX均价(ETH)",
        totalChange:'当日总手续费折合(ETH)',
        returnCharge:"当日挖矿手续费返还(BHB)",
        todayChargeReturn:"当日挖矿收入倍增计划返还（BHB）"*/
    },
    //     brand: {
    //     digital_platform：「」、
    //     rich_digital：「」、
    //     High_quality_digital：「」、
    //     Turnover：「」、
    //     safety_risk：「」、
    //     multi_factor：「」、
    //     Security_reserve：「」、
    //     accident：「」、
    //     safetyrisk：「」、
    //     choice_trusted：「」、
    //     transaction_service：「」、
    //     ten_thousand：「万」、
    //     User_preference：「」、
    //     Countries_covered:''
    //     },

    home: {
        login: {
            title: '貨幣取引を開始する',
            desc: '500+貨幣と多種の取引ツールをサポートする',
            btnText: '取引に行く'
        },
        unlogin: {
            title: 'デジタル通貨の旅を始めよう',
            desc: '登録享受新人福祉大祝儀袋',
            placinfo: '携帯電話/メールボックス',
            btnText: '登録'
        },
        WelfareCenter: '福祉センター',
        Welcome_ceremony: '新年の贈り物',
        Airdrop: '必空投',
        DailyGain: '日日得',
        AirdropGift: '空中投下大礼',
        financial_management: '好ましくは財テク・',
        Zhoude: '周得',
        height_is: 'ガンダム',
        Happiness: '五福カーニバル・',
        Monthly: '月月得',
        CarveUp: '分割',
        download: {
            transactions_anytime: 'いつでもどこでも、取引を開始する',
            scan_code: '豊富なデジタル資産取引及び資産管理サービス、多様な取引ニーズを満たす',
            download_more: 'もっとダウンロード'
        },
        brand: {
            digital_platform: '先進的なデジタル資産取引プラットフォーム',
            rich_digital: '豊富なデジタル資産取引及び資産管理サービス、多様な取引ニーズを満たす',
            High_quality_digital: '高品質デジタル資産',
            Turnover: '出来高',
            safety_risk: '世界トップクラスの安全風制御システム',
            multi_factor: 'オフラインストレージ方式、多要素暗号化手段、7日間24時間年中無休のプラットフォーム監視、全方位保護ユーザー資産安全',
            Security_reserve: '安全準備金',
            accident: '9年0事故',
            safetyrisk: 'トップセーフティウインドコントロール',
            choice_trusted: '1000万人のユーザーが信頼する選択肢',
            transaction_service: '世界の複数の国家地区に現地化取引サービスセンターを設立し、多業務形態が一体となったブロックチェーン生態圏を構築する',
            ten_thousand: '万',
            User_preference: 'ユーザープリファレンス',
            Countries_covered: 'カバレッジ・ナショナル'
        },
        trading: {
            digital_currency: 'デジタル通貨の旅を始めよう',
            register: 'ログイン',
            login: '取引に行く',
            currency_transaction: '貨幣取引を開始する',
            to_trade: '取引に行く'
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/lang/jp/index.js